// extracted by mini-css-extract-plugin
module.exports = {"theWildsWrapper":"style_theWildsWrapper__bvPGx","theWildsBlock":"style_theWildsBlock__wbVyW","wildFloatingButton":"style_wildFloatingButton__ZjrMz"};